import { StatusVariant } from '@consigli/types';
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';

import { Dropzone } from './dropzone';
import { FileUploadList } from './file-upload-list';
import { Alert } from '../alert';

interface FileUploadProps {
  files: File[];
  setFiles: (files: File[]) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  accept?: Record<string, string[]>;
  acceptedFileFormats?: string[];
  maxFiles?: number;
  maxSize?: number;
  alert?: {
    title: string;
    description: string;
    variant: StatusVariant;
  };
}

export const FileUpload = ({
  files,
  setFiles,
  className,
  disabled = false,
  accept,
  acceptedFileFormats,
  maxFiles,
  maxSize,
  alert,
}: FileUploadProps) => {
  // Convert acceptedFileFormats string array to react-dropzone accept format
  const convertedAccept = useMemo(() => {
    if (acceptedFileFormats && acceptedFileFormats.length > 0) {
      const acceptObject: Record<string, string[]> = {};
      acceptedFileFormats.forEach((format) => {
        acceptObject[format] = [];
      });
      return acceptObject;
    }
    return accept;
  }, [acceptedFileFormats, accept]);

  const removeFile = useCallback(
    (indexToRemove: number) => {
      const updatedFiles = files.filter((_, index) => index !== indexToRemove);
      setFiles(updatedFiles);
    },
    [files, setFiles],
  );

  return (
    <div className={clsx('space-y-3', className)}>
      {alert && (
        <Alert variant={alert.variant} title={alert.title} description={alert.description} />
      )}
      <Dropzone
        files={files}
        setFiles={setFiles}
        disabled={disabled}
        accept={convertedAccept}
        maxFiles={maxFiles}
        maxSize={maxSize}
      />

      {files.length > 0 && <FileUploadList files={files} removeFile={removeFile} />}
    </div>
  );
};
